export default __webpack_public_path__ + "static/media/Papo-Seco-Small.1ebba3d7.jpg";